/**
 * Feature toggle to show new UI for account settings left nav
 * @deprecated Feature has been rolled out and setting will be removed once client usages are removed
 */ export var ENABLE_ACCOUNT_SETTINGS_LEFT_NAV_V2_UI_240808 = 'ENABLE_ACCOUNT_SETTINGS_LEFT_NAV_V2_UI_240808';
